import { Component, inject } from '@angular/core'

import { TranslatePipe, TranslateService } from '@ngx-translate/core'

import { BreadcrumbsComponent } from '../../../../components/breadcrumbs/breadcrumbs.component'
import { OurSubscriptionsComponent } from '../../../../pages/home/components/our-subscriptions/our-subscriptions.component'
import type { BreadcrumbItem } from '../../../../types/types'

@Component({
  selector: 'dhp-advertisement-page',
  templateUrl: './advertisement-page.component.html',
  styleUrl: './advertisement-page.component.scss',
  imports: [BreadcrumbsComponent, OurSubscriptionsComponent, TranslatePipe],
})
export class AdvertisementPageComponent {
  private translateService = inject(TranslateService)

  breadcrumbs: BreadcrumbItem[] = []
  oneMonthPrice = 2100
  extraMonthPrice = 900
}
